import Icons from '@/const/icons';
import { Icon } from '../icon';
import { Typography } from '../typography';

interface CloseLabelProps {
	label: string;
}
export const CloseLabel: React.FC<CloseLabelProps> = ({ label }) => {
	return (
		<div className="flex items-center gap-2">
			<span className="text-primary w-3 h-3">
				<Icon src={Icons.closeCircle} width={14} height={14} />
			</span>
			<Typography type="semibold-12" className="line-clamp-1">
				{label}
			</Typography>
		</div>
	);
};
